import * as React from "react";
import { Feed, Input, Pagination, Image , Grid , Icon, Card , Header , Label, Button, Responsive} from 'semantic-ui-react'
import _ from 'lodash'
import { db } from "../../firebase";


interface InterfaceProps {
  gifs?: any,
  handleUpdate ?: any,
  handleDelete ?:any
}

interface InterfaceStates {
  gifsList ?:any,
  activePage ?: any,
  isLoading ?: any,
  results  ?: any,
  value  ?:any
}

export class GifList extends React.Component<InterfaceProps, InterfaceStates> {
  constructor(props: any) {
    super(props);

    this.state = {
        gifsList : [],
        activePage: 1,
        isLoading: false,
        results: [],
        value: ''
    };
  }
  
  
  componentWillMount() {
    const { gifs }: any = this.props;
    const { gifsList }: any = this.state;
    Object.keys(gifs).filter((key) => !!gifs[key]).map((key) => {
        db.doGetUserById(gifs[key].ownerUserId).then(snapshot => {
        const user =snapshot.val();
        let item = gifs[key]
        item.user = user;
        gifsList.push(item)
        this.setState({ gifsList : gifsList})
      });
    })
    this.resetComponent()
  }
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage })
  }
  resetComponent = () => {
    this.setState({ isLoading: false, results: null, value: '' })
    }

  handleSearchChange = (e, { value }) => {
    const { gifs }: any = this.props;
    this.setState({ isLoading: true, value })

    setTimeout(() => {
      if (this.state.value.length < 1) return this.resetComponent()

      const re = new RegExp(_.escapeRegExp(this.state.value))
      const isMatch = result => re.test(result.title)
      this.setState({
        isLoading: false,
        results: _.filter(gifs, isMatch),
      })
    }, 300)
  }
  

  public render() {
    const { handleUpdate, handleDelete }: any = this.props;
    const {activePage, value, isLoading, results, gifsList }: any = this.state;
    const usedList = results ? results : gifsList
    const filtredGifKeysArray = Object.keys(usedList).filter(key => !!usedList[key])
    return (
    <div>
       { usedList && 
          <Grid columns={2}>
            <Grid.Column>
              <Header as='h2'>List of Gifs </Header> 
            </Grid.Column>
            <Grid.Column>
              <Input 
                style = {{float:"right", marginBottom: "10px"}}
                loading = {isLoading}
                icon='search' 
                value={value}
                onChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                placeholder='Search...' 
                size = "small"/>  
            </Grid.Column>
          </Grid>}
        <Grid columns={4}>
          {usedList && filtredGifKeysArray.slice((activePage - 1) * 8, (activePage * 8) ).map(key => {
            return (
              <Grid.Column key={key}>
                <Card>
                    <Image src={usedList[key].URL} /> 
                    <Card.Content>
                      <Card.Header>{usedList[key].title}
                         <Card.Meta style={{float:"right", fontSize:"12px"}}>
                          <Icon name='like' /> {usedList[key].favorites} Like
                        </Card.Meta>
                      </Card.Header>
                      <Card.Description>{usedList[key].description}</Card.Description>
                        { usedList[key].user && <Feed>
                          <Feed.Event>
                            <Feed.Label image={usedList[key].user.photo} />
                            <Feed.Content>
                                {usedList[key].user.name}
                            </Feed.Content>
                          </Feed.Event>
                        </Feed> }
                      <Card.Meta>
                        {usedList[key].tags && Object.keys(usedList[key].tags).map(i => {
                          return (
                          <Label key={i} as='a' size="tiny" color='teal' tag>
                            {usedList[key].tags[i].text}
                          </Label> 
                          )}
                          )
                        } 
                      </Card.Meta>
                    </Card.Content>
                    <Card.Content extra>
                        <div className='ui two buttons'>
                              <Responsive
                                  as={Button}
                                  basic
                                  onClick={()=> {handleUpdate(usedList[key])}}
                                  content='Edit'
                                  icon='tags'
                                  color='green'
                                  minWidth={Responsive.onlyLargeScreen.minWidth}
                              />
                              <Responsive
                                  as={Button}
                                  basic
                                  onClick={()=> {handleUpdate(usedList[key])}}
                                  icon='tags'
                                  color='green'
                                  maxWidth={Responsive.onlyLargeScreen.minWidth}
                              />
                              <Responsive
                                  as={Button}
                                  basic
                                  onClick={()=> {handleDelete(usedList[key])}}
                                  content='Delete'
                                  icon='trash alternate'
                                  color='red'
                                  minWidth={Responsive.onlyLargeScreen.minWidth}
                              />
                              <Responsive
                                  as={Button}
                                  basic
                                  onClick={()=> {handleDelete(usedList[key])}}
                                  icon='trash alternate'
                                  color='red'
                                  maxWidth={Responsive.onlyLargeScreen.minWidth}
                              />
                        </div>    
                    </Card.Content>
                  </Card>
              </Grid.Column>
            )
          })}
      </Grid>
      <br />
      <div>
      { !!filtredGifKeysArray && filtredGifKeysArray.length > 0 && 
          <div style={{ textAlign:"center"}}>
            <Pagination  
            activePage={activePage}
            onPageChange={(e,{activePage}) => this.handlePaginationChange(e, {activePage})}
            totalPages={filtredGifKeysArray.length % 8 === 0 ? filtredGifKeysArray.length / 8 : Math.floor(filtredGifKeysArray.length / 8) + 1}
            />
          </div> }
      </div>
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/gifs/gifList.tsx